// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"40e53483","185":"23182a22","221":"0d23f618","626":"2e6a35df","787":"6ad8f253"}[chunkId] + ".chunk.js";
};